/**
 * Pulls the `token` parameter out of a hash-router URL hash like
 * `"#/reset-password?token=abc123"`. Returns `""` when the hash is empty,
 * has no query-string portion, or has a query-string with no `token`.
 *
 * Pure: takes the hash string explicitly so callers can decide where to
 * read it from. The legacy view tier passes `window.location.hash`; the
 * CLI smoke / tests pass arbitrary fixtures.
 *
 * The two-step parse — split off the `?...` portion, then `URLSearchParams`
 * the result — preserves the historical behavior in `passwordreset.vm.ts`,
 * including a no-throw promise on hashes without a `?` (since
 * `URLSearchParams("")` is valid).
 */
export function parseResetToken(hash: string | undefined | null): string {
	if (!hash) return "";
	const queryString = hash.split("?")[1];
	const params = new URLSearchParams(queryString);
	return params.get("token") ?? "";
}
